import { graphql } from "gql.tada";
import { LinkFragment } from "@queries/fragments/LinkFragment";
import { IconGridFragment } from "@queries/fragments/IconGridFragment";
import { MetadataFragment } from "@queries/fragments/MetadataFragment";
import { RichEntryFragment } from "@queries/fragments/RichEntryFragment";
import { ThemeFragment } from "@queries/fragments/ThemeFragment";
import { QuotationCarouselSectionFragment } from "@queries/fragments/QuotationCarouselSectionFragment";
import { CaseStudyCardSectionFragment } from "@queries/fragments/CaseStudyCardSectionFragment";

export const GetCaseStudyHomepageById = graphql(
  `
    query GetCaseStudyHomepageById(
      $id: String!
      $locale: String
      $preview: Boolean
    ) {
      caseStudyHomepage(id: $id, preview: $preview, locale: $locale) {
        __typename
        slug
        title
        theme { ...ThemeFragment }
        metadata { ...MetadataFragment }
        localizationMarkets
        hero {
          sys { id }
          variant
          title
          subtitle
          description
          ctaText
          ctaLink
          backgroundImage { url contentType }
          overlayImage { url }
          previewVideo { url contentType }
          fullVideo { url contentType }
          fullWidthImage { url contentType }
          eyebrowImagesCollection {
            items { url contentType }
          }
          bodyRichText { ...RichEntryFragment }
        }
        caseStudyShowcase {
          __typename
          ... on CaseStudyCardSection {
            ...CaseStudyCardSectionFragment
          }
        }
        caseStudyInsightsCollection {
          items { ...RichEntryFragment }
        }
        highlightedQuotations {
          ...QuotationCarouselSectionFragment
        }
        additionalClientIcons { ...IconGridFragment }
        ctaFooter {
          sys { id }
          variant
          isVertical
          title
          titleRichText { json }
          cta { ...LinkFragment }
          backgroundImage { url title }
        }
      }
    }
  `,
  [
    LinkFragment,
    IconGridFragment,
    MetadataFragment,
    RichEntryFragment,
    ThemeFragment,
    QuotationCarouselSectionFragment,
    CaseStudyCardSectionFragment,
  ]
);
